import React from 'react';
import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import {
  Button,
  Stack
} from '@mui/material';
import { Add } from '@mui/icons-material';

export type SelectPersonInWorkEventFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {
  handleCreatePerson?: () => void;
};

export const FC = <T extends object>(props: SelectPersonInWorkEventFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const isCreate = __isCreate(props.form.formState);

  return (
    <Stack
      direction='row'
    >
      <StyledDropDown.FC
        {...props.form.genFieldProps(props.fieldName)}
        options={data}
        disabled={isCreate ?? false}
        label={(
          <>
            {props.form.genFieldProps(props.fieldName)?.label ?? ''}
            {isCreate
              ? (
                <Button
                  onClick={() => props.handleCreatePerson && props.handleCreatePerson()}
                  sx={{
                    marginLeft: '2rem',
                    paddingY: '.25rem'
                  }}
                  startIcon={(<Add />)}
                  variant='outlined'
                >
                  Cancel
                </Button>

              )
              : (
                <Button
                  onClick={() => props.handleCreatePerson && props.handleCreatePerson()}
                  sx={{
                    marginLeft: '2rem',
                    paddingY: '.25rem'
                  }}
                  startIcon={(<Add />)}
                  variant='outlined'
                >
                  Add
                </Button>
              )}

          </>
        )}
      />

    </Stack>

  );
};

function __isCreate<T extends object>(formState: T): boolean {
  if ('createPerson' in formState && typeof formState.createPerson === 'boolean') {
    return formState.createPerson;
  }
  return false;
}



